export const productLandingPageFormScroll = {
  form: 'form',
};
